/** Tipos de movimiento de stock (backend: tipo_movimiento_stock) y cómo se muestran. */
export type TipoMovimiento =
  | 'INGRESO_COMPRA' | 'DEVOLUCION_CLIENTE' | 'AJUSTE_POSITIVO'
  | 'SALIDA_VENTA' | 'BAJA_ROTURA' | 'BAJA_VENCIMIENTO' | 'DEVOLUCION_PROVEEDOR' | 'AJUSTE_NEGATIVO'
  | 'TRANSFERENCIA';

export const TIPO_MOVIMIENTO_LABEL: Record<TipoMovimiento, string> = {
  INGRESO_COMPRA: 'Ingreso por compra',
  DEVOLUCION_CLIENTE: 'Devolución de cliente',
  AJUSTE_POSITIVO: 'Ajuste positivo',
  SALIDA_VENTA: 'Salida por venta',
  BAJA_ROTURA: 'Baja por rotura',
  BAJA_VENCIMIENTO: 'Baja por vencimiento',
  DEVOLUCION_PROVEEDOR: 'Devolución a proveedor',
  AJUSTE_NEGATIVO: 'Ajuste negativo',
  TRANSFERENCIA: 'Transferencia',
};

/** Etiqueta de un tipo (el código tal cual si es uno nuevo). */
export const etiquetaTipoMovimiento = (t: string) => TIPO_MOVIMIENTO_LABEL[t as TipoMovimiento] ?? t;
